import { Component, ViewChild, OnInit } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { environment } from '../../environments/environment';
import { DynamicFormComponent } from '../_dynamic_form/containers/dynamic_form/dynamic-form.component';
import { OrdersService } from 'app/_services/orders.service';
import { CookieService } from 'ngx-cookie-service';
import { ObjectFilterPipe } from '../_pipes/object-filter.pipe';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
})
export class OrdersComponent implements OnInit {
  @ViewChild(DynamicFormComponent) filterForm: DynamicFormComponent;

  orders: any[] = [];
  selectedOrder: any;

  storeId: any;
  cookieStore: any;
  role: any;
  routeRole: any;

  filters: any;

  sidebarVisible = false;

  pageSizes: any = environment.pageSizes;
  pagination: any;

  selectedSort: any;

  sortFields: any[] = [
    // {
    //     sortName: 'Name (asc)',
    //     sortString: 'cathedralEyeUser.user.firstName,asc'
    // },
    // {
    //     sortName: 'Name (desc)',
    //     sortString: 'cathedralEyeUser.user.firstName,desc'
    // },
    {
      sortName: 'Order Date (desc)',
      sortString: 'orderTime,desc',
    },
    {
      sortName: 'Order Date (asc)',
      sortString: 'orderTime,asc',
    },
  ];

  filterFields: any[] = [
    {
      type: 'input',
      label: 'Order #ID',
      name: 'id',
      placeholder: 'Enter order id',
    },
    {
      type: 'input',
      label: 'Customer',
      name: 'customer',
      placeholder: 'Enter customer name',
    },
    {
      label: 'Submit',
      name: 'submit',
      type: 'button',
    },
  ];

  constructor(
    public loader: LoadingBarService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public globals: Globals,
    public fb: FormBuilder,
    public notificationService: NotificationService,
    public _ordersService: OrdersService,
    public cookieService: CookieService,
    public objectFilter: ObjectFilterPipe
  ) {
    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;
    this.selectedSort = this.sortFields[0];
    this.resetPagination();
  }

  ngOnInit() {
    this.getAllOrders();
  }

  public getAllOrders() {
    this._ordersService.getAllORdersByStore(this.storeId, this.pagination, this.selectedSort.sortString, this.filters).subscribe((data: any) => {
      console.log('orders', data);

      this.orders = this.objectFilter.transform(data.body, 'awaitingPayment', false);

      // this.orders = data.body;
    });
  }

  // Handle onRowSelect (ie Select Single Patient and navigate to inner view)
  onRowSelect(event) {
    this.router.navigate(['/' + this.globals.user.routeRole + '/orders/' + event.data.id]);
  }

  /* PAGINATION */
  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 1000,
    };
  }

  paginate(event) {
    console.log('paginate', event);
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.getAllOrders();
  }
  /* PAGINATION END */

  // FILTER AND SORTING

  sortChange(event) {
    this.selectedSort = event;
    this.resetPagination();
    this.getAllOrders();
  }

  filterFormSubmitted(value) {
    this.sidebarVisible = false;
    this.filters = value;
    this.getAllOrders();
    this.resetPagination();
  }

  clearFilters() {
    this.sidebarVisible = false;
    this.filters = '';
    this.filterForm.clearForm();
    this.getAllOrders();
    this.resetPagination();
  }
}



// WEBPACK FOOTER //
// ./src/app/orders/orders.component.ts